import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ObserverEmitter, { EVENTS } from "../../../emitter/Observer";
import { ButtonPlay } from "../../../components/common/ButtonPlay";
import { ButtonHome } from "../../../components/common/ButtonHome";
import { HeaderRedPresentation } from "../../../components/common/HeaderRedPresentation";
import { PanelActivities } from "../../../components/common/PanelActivities";
import { tasksId } from "../../../types/activityTasks";
import { useGetActivitiesBySubTopic } from "../../../hooks/useGetActivitiesBySubTopic";
import { ModalInfoTextV2 } from "../../../components/common/ModalInfoTextV2";
import { DialogBarNew } from "../../../components/common/DialogBarNew";
import { ValidationResultModal } from "../../../components/common/ValidationResultModal";
import { completeOneTask } from "../../../store/slices/menu/tunks";
import { useNavigate } from "react-router-dom";
import { audiosAssets } from "../../../assets/audio";
import { imgTema2 } from "../../../assets/tema2";
import { BarStatusActivies } from "../../../components/common/BarStatusActivies";
import { voicesTypeControl } from "../../../types/audioType";
import { ButtonReturn } from "../../../components/common/ButtonReturn";

const steps = {
	dialogInitial: 1,
	panelActivity: 2,
	dialogTwo: 3,
	panelOne: 4,
	panelTwo: 5,
	panelThree: 6,
	win: 7,
};

export const Team2SubtopicTwoActivityOne = () => {
	const navigator = useNavigate();
	const dispatch = useDispatch()
	const [uiToShow, setUiToShow] = useState(steps.dialogInitial);
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema2.activities.subtema2], 1);

	useEffect(() => {
		if (loaded) {
			console.log('tema 2 sub 2 act 1');
			ObserverEmitter.emit(EVENTS.team2.subtopicTwo.initScene, 1);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.onOxxoScene)
		}
	}, [loaded]);

	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T2.sub02.sub2_act1_a01T2)
	})

	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1, -1, -2].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.team2.subtopicTwo.initScene, 1);
						setUiToShow(1)
					}} />
				)}
			</>
			{uiToShow === steps.dialogInitial && (
				<>
					<HeaderRedPresentation name="Actividad 1: Operación Maquinas de café Preparación del café" />
					<DialogBarNew
						dialog={
							"Gracias por continuar con tu recorrido. Es momento de que conozcas uno de los productos estrella de nuestra tienda. Aquí vienen los clientes para recargar su energía con la mejor bebida: ¡Café Andatti!"
						}
						percentage={"50%"}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							setUiToShow(steps.panelActivity);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.panelActivity && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 2: Máquinas de café"
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T2.sub02.sub2_act1_a02T2)
							ObserverEmitter.emit(EVENTS.characterAnimations.saludo);
							setUiToShow(steps.dialogTwo);
						}}
						activities={tasksList}
					/>
				</>
			)}
			{uiToShow === steps.dialogTwo && (
				<>
					<BarStatusActivies activities={tasksList} />
					<DialogBarNew
						dialog={
							"Es momento de hablar acerca de nuestro particular y especial, café de grano."
						}
						percentage={"50%"}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							setUiToShow(steps.panelOne);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.panelOne && (
				<>
					<ModalInfoTextV2
						title="La máquina de café de grano debe contener lo siguiente:"
						url={imgTema2.cafeBote}
						callback={() => {
							setUiToShow(steps.panelTwo);
						}}
					>
						<div className="text-[12px] md:text-[16px] w-full h-full flex flex-col gap-1">
							<p>1.- El garrafón debe tener por lo menos 1/4 de agua y la manguera debe estar por debajo del nivel.</p>
							<p>2.- El contenedor del molino debe tener una bolsa completa de grano o al menos la mitad.</p>
							<p>3.- Debe tener un porta filtro nuevo después de cada uso.NOTA: Si la máquina no enciende verifica que el portafiltro esté en su lugar y que haya suficiente agua.</p>
						</div>
					</ModalInfoTextV2>
				</>
			)}
			{uiToShow === steps.panelTwo && (
				<>
					<ModalInfoTextV2
						title="Contamos con 4 tipos de café de grano:"
						url={imgTema2.cafeCafetera}
						callback={() => {
							setUiToShow(steps.panelThree);
						}}
					>
						<div className="text-[12px] md:text-[16px] w-full h-full flex flex-col gap-1">
							<p>1.- Temporada </p>
							<p>(Nivel de la mirilla encima del nivel 3)</p>
							<p>2.- Descafeinado</p>
							<p>(Nivel de la mirilla encima del nivel 3)</p>
							<p>3.- Clásico</p>
							<p>(Nivel de la mirilla encima del nivel 3)</p>
							<p>4.- Intenso </p>
							<p>(Nivel de la mirilla encima del nivel 2 sin llegar al nivel 3)</p>
						</div>
					</ModalInfoTextV2>
				</>
			)}
			{uiToShow === steps.panelThree && (
				<>
					<ModalInfoTextV2
						title="Es importante limpiar el filtro, o el sabor del café no será el óptimo:"
						url={imgTema2.cafesprite}
						callback={() => {
							setUiToShow(steps.win);
						}}
					>
						<div className="text-[12px] md:text-[16px] w-full h-full flex flex-col gap-1">
							<p>Frecuencia de limpieza: </p>
							<p>Cada preparación de café</p>
							<p>1.- Retira el porta filtro y tira el filtro a la basura.</p>
							<p>2.- Enjuaga el porta filtro a chorro de agua y sécalo con papel secante.</p>
							<p>3.- Coloca un filtro nuevo en el porta filtro y colócalo de nuevo en la máquina de café.</p>
						</div>
					</ModalInfoTextV2>
				</>
			)}
			{uiToShow === steps.win && (
				<>
					<ValidationResultModal
						title="¡Bien hecho!"
						dialogModal="Recuerda revisar constantemente los niveles de agua al igual que los filtros siempre estén limpios."
						buttonTxt="Continuar"
						isCorrect={true}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 1,
									pointsWin: 0,
									subtema: tasksId.tema2.activities.subtema2,
								})
							);
							navigator("/home2/tema2/subtema2/activityTwo");
						}}
					/>
				</>
			)}
		</>
	);
};
